export default {
  name: 'title-from-text',
  directive: {
    inserted: function (el, binding) {
      el.title = binding.value || el.innerText
    },
    componentUpdated: function (el, binding) {
      el.title = binding.value || el.innerText
    }
  }
}
